import type { GroupJSON } from 'balus-common';
import { GroupAnalysisSetting } from './GroupAnalysisSetting';
import { GroupMemberSignUpMethod } from './GroupMemberSignUpMethod';

export class GroupSetting {
  constructor(
    public readonly availableSignUpMethods: GroupMemberSignUpMethod,
    public readonly analysisSetting: GroupAnalysisSetting,
    public readonly enableIndividualViewModelPermissions: boolean
  ) {}

  dump(): GroupJSON['setting'] {
    const { availableSignUpMethods, analysisSetting, enableIndividualViewModelPermissions } = this;
    return {
      availableSignUpMethods: availableSignUpMethods.dump(),
      analysisSetting: analysisSetting.dump(),
      enableIndividualViewModelPermissions,
    };
  }

  static load(dump: GroupJSON['setting']): GroupSetting {
    const { availableSignUpMethods, analysisSetting, enableIndividualViewModelPermissions } = dump;
    return new this(
      GroupMemberSignUpMethod.load(availableSignUpMethods),
      GroupAnalysisSetting.load(analysisSetting),
      enableIndividualViewModelPermissions || false
    );
  }

  static buildNew(): GroupSetting {
    return new this(GroupMemberSignUpMethod.buildNew(), GroupAnalysisSetting.buildNew(), false);
  }
}
